import React from "react";
import { useSelector } from "react-redux";
import styles from "./ccToast.module.scss";
import { initialStateModel, LoginState } from "../../../models/model";
import { ChatService } from "../../../base/chatService";
import { Types } from "../../../context/action/action";
import store from "../../../context/store/store";


export default function CCToast() {


  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
let {ccMessage}=store.getState().meetingReducer;
  return (
    <>  
      <div className={styles.toastScreenleft}>
        <span className={`icon_info ${styles.iconIcon}`} />
        <span className="">{ccMessage}</span>
        <span className={`icon_close ${styles.iconIconclose}`} />
      </div>
     
    </>
  );
};